import { Modal as M } from "react-bootstrap";
import { useGeneralAppStore } from "../../store/generalAppStore";

const Modal = ({ size, show, onHide, setShow, title, footer, children, loading, fullscreen = null, backdrop = true }) => {
  const hide = () => setShow(false);
  const { modals } = useGeneralAppStore()

  // console.log(modals)

  return (
    <M
      fullscreen={fullscreen}
      show={show}
      onHide={onHide ?? hide}
      size={size ? size : "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={backdrop}
      style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
    // style={{
    //   backgroundColor: (modals.length > 1 && modals[0] === 'acta_detalle') || modals.includes('modal_imprimir_actas') || modals.includes('notificadores_table')  || modals.includes('modal_desasignar_acta') || modals.includes('notificadores') ? 'rgba(0,0,0,0.4)' : '',
    // }}
    // opacity: modals.length > 1 && modals[0] === 'acta_detalle' ? '.1' : '1',        
    >
      <M.Header closeButton>
        <M.Title id="contained-modal-title-vcenter ">{!loading && title()}</M.Title>
      </M.Header>
      <M.Body>{children}</M.Body>
      {footer && <M.Footer>{!loading && footer()}</M.Footer>}
    </M>
  );
};

export default Modal;
